
import { computed, defineComponent } from 'vue';

export default defineComponent({
  name: 'QaSelect',
  props: {
    modelValue: {
      type: [String, Number],
    },
  },
  emits: {
    'update:modelValue': null,
  },
  setup(props, { emit }) {
    const value = computed({
      get: () => props.modelValue,
      set: (value) => emit('update:modelValue', value),
    });

    return {
      value,
    };
  },
});
